export default "__VITE_ASSET__DgxlUXWC__"